<div class="widgets-container">
    <mat-toolbar class="grow-toolbar px-0 mb-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="sidebar-btn" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button (click)="sidenavService.toggle()" *ngIf="!isLargeScreen">
                <mat-icon>apps</mat-icon>
            </button>
            <div *ngIf="audience && audience.parent; else defaultAudienceTitle">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-icon-button class="mr-4" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <div fxLayout="column">
                        <h5 class="parent-name">{{ audience.name | audienceDisplayName }}</h5>
                        <h2>{{ 'ENGAGE.AUDIENCE.LABELS.RELEVANT_EXPERIENCES' | translate }}</h2>
                    </div>
                </div>
            </div>
            <ng-template #defaultAudienceTitle>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-icon-button class="mr-4" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <div fxLayout="column">
                        <h5 class="parent-name" *ngIf="audience">{{ audience.name | audienceDisplayName }}</h5>
                        <h2>{{ 'ENGAGE.AUDIENCE.LABELS.RELEVANT_EXPERIENCES' | translate }}</h2>
                    </div>
                </div>
            </ng-template>
        </div>
    </mat-toolbar>

    <div class="widgets">
        <mat-card class="p-0 mb-12 widget-card trending-courses mat-elevation-z0" *ngFor="let widget of widgets">
            <div
                *ngIf="widget.experience.headerBanner && widget.experience.headerBanner.image"
                mat-card-avatar
                class="experience-card-image"
                [style.background-image]="'url(' + widget.experience.headerBanner.image.url + ')'"
            ></div>
            <mat-card-content fxLayout="column" fxLayoutAlign="center start">
                <span class="experiance-name">{{ widget.name | translate }}</span>
                <div fxLayout="row" fxLayoutAlign="space-between center" class="w-full">
                    <p class="my-0" fxFlex="33">
                        {{ widget.experience.name | translate }}
                    </p>

                    <p class="my-0" fxFlex="33">
                        {{ 'ENGAGE.AUDIENCE.LABELS.MEMBERS_COUNT' | translate: { total: widget.experience.memberCount } }}
                    </p>

                    <p class="my-0" fxFlex="33">
                        {{ 'ENGAGE.AUDIENCE.LABELS.WIDGETS_COUNT' | translate: { total: widget.experience.widgetCount } }}
                    </p>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <!-- Wrap to allow tooltip on disabled toggle -->
                <span
                    [matTooltip]="getToggleDisabledTooltip(widget)"
                    [matTooltipDisabled]="!isToggleDisabled(widget)"
                    matTooltipPosition="above"
                >
                    <mat-slide-toggle
                        class="mr-8"
                        [checked]="widget.status === AudienceExperienceStatusEnum.RELEVANT"
                        [disabled]="isToggleDisabled(widget)"
                        (change)="updateStatus(widget, $event.checked)"
                    >
                        {{ 'ENGAGE.AUDIENCE.LABELS.RELEVANT_FOR_AUDIENCE' | translate }}
                    </mat-slide-toggle>
                </span>
            </mat-card-actions>
        </mat-card>
    </div>
</div>
